import { render, staticRenderFns } from "./PasswordPolicy.vue?vue&type=template&id=4f0bc83a"
import script from "./PasswordPolicy.vue?vue&type=script&lang=js"
export * from "./PasswordPolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports